// 平台 - 首页及通用
// ============================================================================
// 开发者权限
export const P_DEV = 'Platform_Developer';

// 用户跟踪数据查看权限
export const P_TRACK = 'Platform_DataTracking';

// OSS文件管理
export const P_OSS = 'Platform_OssFileManagement';


// 平台 - 组织和用户
// ============================================================================
// 组织管理
export const P_ORG = 'Platform_OrganizationManagement';

// 组织查看
export const P_ORG_VIEW = 'Platform_OrganizationViewManagement';

// 组织新增
export const P_ORG_ADD = 'Platform_OrganizationAddManagement';

// 用户和角色管理
export const P_USER = 'Platform_UserManagement';

// 会员管理
export const P_MEMBER = 'Platform_MemberManagement';

// 增值服务
export const P_MOD = 'Platform_ModuleManagement';

// 客服管理
export const P_CSM = 'Platform_CustomerServiceManagement';

// 客户服务
export const P_CSA = 'Platform_CustomerService';


// 平台 - 基础信息
// ============================================================================
// 品牌管理
export const P_BRAND = 'Platform_BrandManagement';

// 品牌授权
export const P_BRAND_AUTH = 'Platform_BrandAuthorizationManagement';

// 属性和过滤项管理
export const P_FILTER = 'Platform_FilterItemManagement';

// 字典管理
export const P_DICT = 'Platform_DictionaryManagement';

// 字典编辑
export const P_DICT_EDIT = 'Platform_DictionaryEdit';

// 关键字管理
export const P_KEYWORD = 'Platform_KeyWordManagement';

// 告知管理
export const P_MSG = 'Platform_MessageManagement';

// 客户端配置
export const P_CLIENT = 'Platform_ClientManagement';

// 定时任务
export const P_TASK = 'Platform_TaskManagement';


// 平台 - 物料
// ============================================================================
// 物料管理
export const P_ITEM = 'Platform_ItemManagement';

// 物料发布
export const P_ITEM_PUB = 'Platform_ProductPublishManagement';

// 物料导航管理
export const P_ITEM_NAV = 'Platform_ItemNavManagement';

// 物料导航发布
export const P_ITEM_NAV_PUB = 'Platform_ItemNavPublishManagement';

// 物料品牌管理（用于物料品牌迁移）
export const P_ITEM_BRAND = 'Platform_ItemBrandManagement';

// 型材产品管理
export const P_SEC_PROD = 'Platform_SectionProductManagement';

// 型材产品发布管理
export const P_SEC_PROD_PUB = 'Platform_SectionProductPublishManagement';

// 型材产品导航管理
export const P_SEC_PROD_NAV = 'Platform_SectionProductNavManagement';

// 型材产品导航发布
export const P_SEC_PROD_NAV_PUB = 'Platform_SectionProductNavPublishManagement';

// 价格管理
export const P_PRICE = 'Platform_ProductPriceManagement';


// 平台 - 拼装家具
// ============================================================================
// 零件管理
export const P_COMP = 'Platform_AssetComponentManagement';

// 零件发布
export const P_COMP_PUB = 'Platform_AssetComponentPublishManagement';

// 模块管理
export const P_BLOCK = 'Platform_AssetBlockManagement';

// 模块发布
export const P_BLOCK_PUB = 'Platform_AssetModulePublishManagement';

// 家具导航管理
export const P_FUR_NAV = 'Platform_FurnitureNavManagement';

// 家具导航发布
export const P_FUR_NAV_PUB = 'Platform_FurnitureNavPublishManagement';


// 平台 - 素材
// ============================================================================
// 模型管理
export const P_UEITEM = 'Platform_UeItemManagement';

// 型材管理
export const P_SEC_BAR = 'Platform_SectionBarManagement';

// 道具管理
export const P_PROP = 'Platform_AssetStagePropertyManagement';

// 道具发布
export const P_PROP_PUB = 'Platform_AssetStagePropertyPublishManagement';


// 平台 - 设计方案
// ============================================================================
// 专案管理
export const P_DESIGN = 'Platform_DesignProjectManagement';

// 专案发布
export const P_DESIGN_PUB = 'Platform_DesignPublishManagement';

// 专案设计
export const P_DESIGNER = 'Platform_Designer';

// 看所有公共专案
export const P_DESIGN_VA = 'Platform_DesignViewAllOnly';

// 专案收集和交付
export const P_DESIGN_TRANS = 'Platform_TransferDesignManagement';

// 专案配置下载
export const P_DESIGN_DL = 'Platform_DownloadDesignConfigManagement';

// 专案误删恢复
export const P_DESIGN_RESTORE = 'Platform_DesignProjectRestoreManagement';

// 专案导航
export const P_DESIGN_NAV = 'Platform_DesignNavManagement';

// 专案导航发布
export const P_DESIGN_NAV_PUB = 'Platform_DesignNavManagement';

// 杂志管理
export const P_MAGAZINE = 'Platform_MagazineManagement';

// 杂志授权
export const P_MAGAZINE_AUTH = 'Platform_MagazineAuthorizationManagement';

// 验收管理
export const P_INSPECT = 'Platform_Design_InspectionManagement';

// 个人专案验收
export const P_INSPECT_DESIGN = 'Platform_Design_Inspection';

// 专案验收
export const P_ACCEPT = 'Platform_Design_Acceptance';

// 板间管理
export const P_ROOM = 'Platform_BlankRoomManagement';

// 界地图管理
export const P_WORLD = 'Platform_OpenWorldManagement';

// 副本管理
export const P_ZONE = 'Platform_RoomInstanceManagement';

// 愿望单管理
export const P_FAV_ALL = 'Platform_AllItemPickingManagement';

// 当前组织愿望单管理
export const P_FAV_ORG = 'Platform_ItemPickingManagement';


// 平台 - 财务
// ============================================================================
// 财务管理
export const P_FD = 'Platform_FinanceManagement';

// 组织激活
export const P_FD_ACTIVE = 'Platform_FinanceActivationManagement';

// 组织升级
export const P_FD_UPGRADE = 'Platform_FinanceUpgradeManagement';

// 组织降级
export const P_FD_DOWNGRADE = 'Platform_FinanceDowngradeManagement';

// 组织续费
export const P_FD_RENEWAL = 'Platform_FinanceRenewalManagement';

// 组织续费查看
export const P_FD_RENEWAL_VIEW = 'Platform_ReNewViewFinanceManagement';

// 组织终止
export const P_FD_TERMINAL = 'Platform_FinanceTerminationManagement';


// 平台 - 品牌数字门店
// ============================================================================
// 品牌门店管理
export const P_BRAND_STORE = 'Platform_BrandStoreManagement';

// 数字内容管理
export const P_DIGITAL_RES = 'Platform_DigitalResourcesManagement';


// 平台 - 数字资产
// ============================================================================
// 数字资产管理
export const P_DA = 'Platform_DigitalAssetManagement';

// 数字资产查看
export const P_DA_VIEW = 'Platform_DigitalAssetView';

// 数字资产日志
export const P_DA_LOG = 'Platform_DigitalAssetLogManagement';

// 数字资产属性管理
export const P_DA_ATTR = 'Platform_DigitalAssetAttributeManagement';

// 数字资产属性发布
export const P_DA_ATTR_PUB = 'Platform_DigitalAssetAttributePublishManagement';

// 数字资产属性日志
export const P_DA_ATTR_LOG = 'Platform_DigitalAssetAttributeLogManagement';

// 数字资产模板管理
export const P_DA_DEF = 'Platform_DigitalAssetDefinitionManagement';

// 数字资产模板发布
export const P_DA_DEF_PUB = 'Platform_DigitalAssetDefinitionPublishManagement';

// 数字资产模板日志
export const P_DA_DEF_LOG = 'Platform_DigitalAssetDefinitionLogManagement';


// 平台 - 官网
// ============================================================================
// 官网内容管理
export const P_WEBSITE_CONTENT = 'Platform_WebSiteContentManagement';

// 官网内容发布
export const P_WEBSITE_CONTENT_PUB = 'Platform_WebSiteContentPublishManagement';


// 平台 - 数据治理
// ============================================================================
// 数据迁出
export const P_MIG_OUT = 'Platform_MigrationOut';

// 数据迁入
export const P_MIG_IN = 'Platform_MigrationIn';

// 缓存管理
export const P_CACHE = 'Platform_CacheManagement';

// 刷新索引
export const P_REFRESH = 'Platform_IndexRefreshManagement';

// 生成缩略图
export const P_THUMB = 'Platform_SmallImageManagement';


// 企业 - 组织和用户
// ============================================================================
// 组织管理
export const D_ORG = 'Distributor_OrganizationManagement';

// 用户管理
export const D_USER = 'Distributor_UserManagement';

// 企业信息管理
export const D_ORG_INFO = 'Distributor_EnterpriseInformationManagement';

// 企业 - 基础信息
// ============================================================================
// 品牌授权
export const D_BRAND_AUTH = 'Distributor_BrandAuthorizationManagement';


// 企业 - 物料
// ============================================================================
// 价格管理(预留, 暂时没用)
export const D_PRICE = 'Distributor_ProductPriceManagement';


// 企业 - 拼装家具
// ============================================================================
// 模块管理
export const D_BLOCK = 'Distributor_AssetBlockManagement';

// 模块发布
export const D_BLOCK_PUB = 'Distributor_AssetModulePublishManagement';

// 模块价格管理(预留, 暂时没用)
export const D_BLOCK_PRICE = 'Distributor_BlockProductPriceManagement ';


// 企业 - 设计方案
// ============================================================================
// 专案管理
export const D_DESIGN = 'Distributor_DesignProjectManagement';

// 专案发布
export const D_DESIGN_PUB = 'Distributor_DesignPublishManagement';

// 专案设计
export const D_DESIGNER = 'Distributor_Designer';

// 查看所有公共专案
export const D_DESIGN_VA = 'Distributor_DesignViewAllOnly';

// 专案收集和交付
export const D_DESIGN_TRANS = 'Distributor_TransferDesignManagement';

// 当前组织愿望单管理
export const D_FAV_ORG = 'Distributor_ItemPickingManagement';


// 企业 - 设计服务
// ============================================================================
// 验收管理
export const D_INSPECT = 'Distributor_Design_InspectionManagement';

// 个人专案验收管理
export const D_INSPECT_DESIGN = 'Distributor_Design_Inspection';

// 方案验收
export const D_ACCEPT = 'Distributor_Design_Acceptance';


// 企业 - 品牌数字门店
// ============================================================================
// 数字门店管理
export const D_BRAND_STORE = 'Distributor_BrandStoreManagement';

// 数字内容管理
export const D_DIGITAL_RES = 'Distributor_DigitalResourcesManagement';


// 企业 - 数字资产
// ============================================================================
// 数字资产管理
export const D_DA = 'Distributor_DigitalAssetManagement';

// 数字资产查看
export const D_DA_VIEW = 'Distributor_DigitalAssetView';

// 数字资产日志
export const D_DA_LOG = 'Distributor_DigitalAssetLogManagement';

// 数字资产属性管理
export const D_DA_ATTR = 'Distributor_DigitalAssetAttributeManagement';

// 数字资产属性发布
export const D_DA_ATTR_PUB = 'Distributor_DigitalAssetAttributePublishManagement';

// 数字资产属性日志
export const D_DA_ATTR_LOG = 'Distributor_DigitalAssetAttributeLogManagement';

// 数字资产模板管理
export const D_DA_DEF = 'Distributor_DigitalAssetDefinitionManagement';

// 数字资产模板发布
export const D_DA_DEF_PUB = 'Distributor_DigitalAssetDefinitionPublishManagement';

// 数字资产模板日志
export const D_DA_DEF_LOG = 'Distributor_DigitalAssetDefinitionLogManagement';
